import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString: string | null | undefined, formatStr: string = 'd. MMMM yyyy'): string {
  if (!dateString) return '';
  try {
    return format(parseISO(dateString), formatStr, { locale: de });
  } catch {
    return dateString;
  }
}

export function formatTime(timeString: string | null | undefined): string {
  if (!timeString) return '';
  const parts = timeString.split(':');
  if (parts.length >= 2) {
    return `${parts[0]}:${parts[1]} Uhr`;
  }
  return timeString;
}

export function calculateAge(birthDate: string | null, deathDate: string | null): number | null {
  if (!birthDate || !deathDate) return null;
  const birth = parseISO(birthDate);
  const death = parseISO(deathDate);
  let age = death.getFullYear() - birth.getFullYear();
  const monthDiff = death.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && death.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}

export function formatLifeSpan(birthDate: string | null, deathDate: string | null): string {
  const birthYear = birthDate ? parseISO(birthDate).getFullYear() : '?';
  const deathYear = deathDate ? parseISO(deathDate).getFullYear() : '?';
  return `${birthYear} – ${deathYear}`;
}

export function getInitials(firstName: string | null, lastName: string | null): string {
  const first = firstName?.charAt(0)?.toUpperCase() || '';
  const last = lastName?.charAt(0)?.toUpperCase() || '';
  return `${first}${last}`;
}
